module.exports = __webpack_public_path__ + "static/media/Group8929.6e7184a4.png";